export default __webpack_public_path__ + "55a101e86a87b98fc1e01ffae7838f8f.svg";